import { writable } from "svelte/store";

export const toasts = writable([]);

export const addToast = (message, type = 'error') => {
  const id = Math.floor(Math.random() * 10000);

  toasts.update((all) => [
    { id, type, message }, 
    ...all,
  ]);

  setTimeout(() => dismissToast(id), 5000);
};

export const dismissToast = (id) => {
  toasts.update((all) => all.filter((t) => t.id !== id));
};